/**
 * Route for `branded-partner-portal-per-sub-network`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BrandedPartnerPortalPerSubNetworkPage } from "../features/branded-partner-portal-per-sub-network/BrandedPartnerPortalPerSubNetworkPage";

export const brandedPartnerPortalPerSubNetworkRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/branded-partner-portal-per-sub-network",
	component: BrandedPartnerPortalPerSubNetworkPage,
});

export default brandedPartnerPortalPerSubNetworkRoute;
